import { render, staticRenderFns } from "./CreditBalanceShop.vue?vue&type=template&id=77d824fa"
import script from "./CreditBalanceShop.vue?vue&type=script&lang=js"
export * from "./CreditBalanceShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports